import { createStyles, MenuItem, StyledComponentProps, TextField, withStyles } from '@material-ui/core';
import { action, computed } from 'mobx';
import { observer } from 'mobx-react';
import { Instance } from 'mobx-state-tree';
import * as React from 'react';
import { IEntity } from '../main/entities';
import { transl } from '../main/transl';
import { mg } from '../mg/mg';
import { DataviewStore_Filtering, IDataviewStore } from '../stores/DataviewStore';
import { IDataviewStoreColumn } from '../stores/DataviewStoreColumn';

interface IOcDataviewFilteringElemProps {
	state: IDataviewStore
	index: number
	repo: {
		allAsList: Array<IEntity>,
	}
}

@observer class _OcDataviewFilteringElem extends React.Component<IOcDataviewFilteringElemProps & StyledComponentProps> {
	@action _onChange = (e: React.ChangeEvent<HTMLInputElement>) => this.props.state.setFilteringValue(this.props.index, '' + e.target.value)

	@computed get _column() : IDataviewStoreColumn | undefined {
		const {state, index} = this.props;
		const f: Instance<typeof DataviewStore_Filtering> = state.filtering[index];
		if (f.columns.length !== 1) return undefined;
		return state.columnByName(f.columns[0]);
	}

	@computed get _choices() : Map<any, string> {
		const {state, index, repo} = this.props;
		const f: Instance<typeof DataviewStore_Filtering> = state.filtering[index];
		const result = new Map<any, string>();
		switch (f.type) {
		case 'BOOLEAN':
			result.set(true, transl('yes'));
			result.set(false, transl('no'));
			return result;
		case 'SELECT': {
			const column = this._column;
			if (!column) return result;
			repo.allAsList.forEach(e => result.set(column.formatForSort(e), column.formatForView(e)));
			result.delete('');
			return result;
		}
		case 'ENUM': {
			const column = this._column;
			if (!column) return result;
			repo.allAsList.forEach(e => result.set(column.accessors(e as any).getter(), column.formatForView(e)));
			result.delete('');
			console.log(result);
			return result;
		}
		case 'NORMAL':
			return result;
		}
	}

	_renderNormal() {
		const classes = this.props.classes || {};
		const {state, index} = this.props;
		const f: Instance<typeof DataviewStore_Filtering> = state.filtering[index];
		return <TextField className={classes.input} margin="dense"
			onChange={this._onChange}
			label={f.label}
			value={f.value}
		/>;
	}

	_renderSelect(isEnumOrBoolean: boolean) {
		const column = this._column;
		if (!column) return this._renderNormal();
		const choices = this._choices;
		if (!choices.size) return this._renderNormal();
		const classes = this.props.classes || {};
		const {state, index} = this.props;
		const f: Instance<typeof DataviewStore_Filtering> = state.filtering[index];
		const list = [...choices.entries()].sort(mg.comparatorOn(([k, v]) => isEnumOrBoolean ? v : k));
		return <TextField className={classes.input} margin="dense" select
			onChange={this._onChange}
			label={f.label}
			value={f.value}
			InputProps={{className: classes.inner}}
		>
			<MenuItem value="" key="">{transl('noFiltering')}</MenuItem>
			{list.map(([k, v]) => <MenuItem value={isEnumOrBoolean ? k : v} key={k}>{v}</MenuItem>)}
		</TextField>;
	}

	render() {
		const {state, index} = this.props;
		const f: Instance<typeof DataviewStore_Filtering> = state.filtering[index];
		switch (f.type) {
		case 'NORMAL': return this._renderNormal();
		case 'BOOLEAN':
		case 'ENUM': return this._renderSelect(true);
		case 'SELECT': return this._renderSelect(false);
		}
	}
}

const OcDataviewFilteringElem = withStyles(createStyles({
	input: {
		display: 'flex',
		flexWrap: 'wrap',
		paddingRight: 20,
		width: 120,
		top: -10,
	},
	inner: {
		maxWidth: '100%',
	},
}))(_OcDataviewFilteringElem);

interface IOcDataviewFilteringProps {
	state: IDataviewStore
	repo: {
		allAsList: Array<IEntity>,
	}
}

const _OcDataviewFiltering = (props: IOcDataviewFilteringProps) : JSX.Element => <>{
	props.state.filtering.map((f, i) =>
		<OcDataviewFilteringElem key={i} state={props.state} repo={props.repo} index={i}/>)
}</>;

export const OcDataviewFiltering = observer(_OcDataviewFiltering);
